import { Link } from "@mui/material";
import { forwardRef } from "react";
import { type LinkProps as RouterLinkProps } from "react-router-dom";

import { BaseLink } from "../BaseLink/Link";
import { type MuiLinkProps } from "../types";

export interface InternalLinkProps extends Omit<MuiLinkProps, "href"> {
  to: RouterLinkProps["to"];
}

/**
 * @deprecated Use the TextButton component from cbh-mobile-app's redesign system to show links instead.
 * ui-components has been removed from cbh-core.
 * Link redirection logic should be handled by the specific application that consumes this component.
 */
export const InternalLink = forwardRef<HTMLAnchorElement, InternalLinkProps>((props, ref) => {
  return <Link ref={ref} component={BaseLink} {...props} />;
});

InternalLink.displayName = "InternalLink";
